import React from 'react';
import { footer } from './data';
import mini_logo from '../imgs/mini_logo.png';

function antCloudFooter() {
  const children = footer.map((item, i) => (<div key={i}><a href={item.src}>{item.text}</a></div>));
  return (<div>
    <div className="logo" key="logo">
      <img src={mini_logo} width="100" height="59" />
    </div>
    <div key="nav" className="home-footer-nav-wrapper">
      {children}
    </div>
  </div>
  );
}

function Footer() {
  return (
    <div className="home-layout-wrapper home-footer-wrapper">
      <div className="home-layout">
        {antCloudFooter()}
        <p key="cop" className="copy">Copyright © 2020 Luigi Frunzio  |  MrLTactics.com</p>
      </div>
    </div>
  );
}

export default Footer;
